export default "__VITE_ASSET__BwBu0XBV__"